module.exports = __webpack_public_path__ + "img/light-f-fm-Path 48 Copy@3x.13560976.png";